module.exports = __webpack_public_path__ + "img/LogoIbillete_Color.94d1a068.png";